import {PaginationData} from '@ngneat/elf-pagination';

export interface TablePagination {
  page: number;
  limit: number;
}

export interface Pagination {
  data: any[];
  total: number;
  count: number;
}

export namespace Pagination {
  export const toPaginationData = (paginationData: Pagination, page = 1): PaginationData => ({
    total: paginationData.total,
    currentPage: page,
    lastPage: Math.ceil(paginationData.data.length / paginationData.count),
    perPage: paginationData.count,
  });
}
